// generic heading component
export default function H1({ children }) {
	return (
		<h1 className="uppercase font-heading font-bold text-4xl sm:text-5xl text-gray-700 dark:text-white mb-4">
			{children}
		</h1>
	);
}
